<p *ngIf="workspaceFileUsers?.length > 0" class="mc-text-info mc-workspace-files-user-status-list-warning">
  <mat-icon class="mc-yet-another-centered-text-icon" fontSet="project-titan" fontIcon="icon-warning-filled"></mat-icon>
  <ng-container *ngIf="warningDirective?.templateRef" [ngTemplateOutlet]="warningDirective.templateRef" [ngTemplateOutletContext]="{ currentUserHasInProgressFiles: currentUserHasInProgressFiles, workspaceFileCount: workspaceFiles?.length }"></ng-container>
</p>

<div *ngIf="workspaceFileUsers?.length > 0" class="mc-form-section mc-avatar-list">
  <ng-container *ngFor="let workspaceFileUser of workspaceFileUsers">
    <mc-license-user-avatar *ngIf="workspaceFileUser.userId | mcLicenseUserForLicenseAsync : licenseId | async as licenseUser" class="mc-avatar-list-item" [licenseUser]="licenseUser" [showName]="false" size="small">
      <ng-template mcAvatarIndicator>
        <mc-workspace-file-user-status-avatar-indicator [workspaceFiles]="workspaceFiles" [workspaceFileUser]="workspaceFileUser"></mc-workspace-file-user-status-avatar-indicator>
      </ng-template>
    </mc-license-user-avatar>
  </ng-container>
</div>

<p *ngIf="!workspaceFileUsers?.length && currentUserHasInProgressFiles && currentUserWarningDirective" class="mc-text-info mc-workspace-files-user-status-list-warning">
  <mat-icon class="mc-yet-another-centered-text-icon" fontSet="project-titan" fontIcon="icon-warning-filled"></mat-icon>
  <ng-container *ngIf="currentUserWarningDirective.templateRef" [ngTemplateOutlet]="currentUserWarningDirective.templateRef"></ng-container>
</p>